/**
 * Small line icons for the kinds of the taxonomy: one shape per kind, so that a folded group,
 * a card of the "new" dialog and a node read at a glance. Drawn in the current colour.
 */
const PATHS: Record<string, string> = {
  object: 'M3 5.5 8 3l5 2.5v5L8 13l-5-2.5z M3 5.5 8 8l5-2.5 M8 8v5',
  event: 'M8 2.5v3 M8 10.5v3 M2.5 8h3 M10.5 8h3 M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4',
  document: 'M4 2.5h5l3 3v8H4z M9 2.5v3h3 M6 8.5h4 M6 11h4',
  value: 'M5 3H3.5v10H5 M11 3h1.5v10H11 M6 8h4',
  values: 'M5 3H3.5v10H5 M11 3h1.5v10H11 M6 8h4',
  template: 'M3 3h10v10H3z M3 6.5h10',
  flows: 'M3.5 4.5a1.5 1.5 0 1 0 0 .01 M12.5 11.5a1.5 1.5 0 1 0 0 .01 M5 4.5h3a2 2 0 0 1 2 2v3a2 2 0 0 0 2 2',
  actions: 'M5 2.5 3 9h4l-1 4.5L12 6H8l1-3.5z',
  rules: 'M3 4h10 M3 8h7 M3 12h4 M12 10l1.5 1.5L12 13',
  bindings: 'M6 10 10 6 M5 7.5 3.5 9a2.1 2.1 0 0 0 3 3L8 10.5 M11 8.5 12.5 7a2.1 2.1 0 0 0-3-3L8 5.5',
  duplicates: 'M3 3h7v7H3z M6 6h7v7H6z',
  approvals: 'M3 8.5 6.5 12 13 4.5',
  notifications: 'M4.5 11V7.5a3.5 3.5 0 0 1 7 0V11l1 1.5h-9z M7 13.5h2',
  conversations: 'M3 4h10v6H7l-3 2.5V10H3z',
  deliveries: 'M2.5 5h7v6h-7z M9.5 7h2.5l1.5 2v2h-4 M5 12.5a1 1 0 1 0 0 .01 M11 12.5a1 1 0 1 0 0 .01',
  series: 'M3 4h2 M3 8h2 M3 12h2 M7 4h6 M7 8h6 M7 12h6',
  retention: 'M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3z M8 5.5V8l2 1.5',
  mappings: 'M3 4.5h4 M3 8h4 M3 11.5h4 M9 4.5h4 M9 8h4 M9 11.5h4 M7 4.5 9 8 M7 11.5 9 8',
  links: 'M6 10 10 6 M5 7.5 3.5 9a2.1 2.1 0 0 0 3 3L8 10.5 M11 8.5 12.5 7a2.1 2.1 0 0 0-3-3L8 5.5',
  mapLayers: 'M2.5 4 6 2.5l4 1.5 3.5-1.5v9.5L10 13.5 6 12l-3.5 1.5z M6 2.5V12 M10 4v9.5',
  boards: 'M2.5 3h3.5v10H2.5z M7 3h3v7H7z M11 3h2.5v5H11z',
  views: 'M2 8s2.2-4 6-4 6 4 6 4-2.2 4-6 4-6-4-6-4z M8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3',
  screens: 'M2.5 3.5h11v7h-11z M6 13h4 M8 10.5V13',
  menu: 'M3 4.5h10 M3 8h10 M3 11.5h10',
  dashboards: 'M3 13V9 M6.5 13V5 M10 13V7.5 M13.5 13V3',
  queries: 'M7 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M10 10l3.5 3.5',
  documents: 'M4 2.5h5l3 3v8H4z M9 2.5v3h3',
  messages: 'M2.5 4h11v8h-11z M2.5 4 8 8.5 13.5 4',
  notificationCategories: 'M3 3h4v4H3z M9 3h4v4H9z M3 9h4v4H3z M9 9h4v4H9z',
  configurators: 'M3 5h6 M11 5h2 M3 11h2 M7 11h6 M10 3.5v3 M6 9.5v3',
  packages: 'M3 5.5 8 3l5 2.5v5L8 13l-5-2.5z M5.5 4.2l5 2.6',
  automation: 'M8 2.5a5.5 5.5 0 1 0 5.5 5.5 M13.5 3v3h-3 M7.5 5 6 8.5h3l-1.5 3',
  state: 'M3 5h10v6H3z'
};

export function KindIcon({ kind, size = 14 }: { kind: string; size?: number }) {
  const d = PATHS[kind] ?? PATHS.template;
  return (
    <svg className="tx-icon" width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
